import React, { Component } from 'react';
import { Calendar, Clock, Video, Users, FileText, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Calendar as CalendarComponent } from '../ui/Calendar';
export function Meetings() {
  const upcomingMeetings = [{
    id: 1,
    title: 'Finance Committee Monthly Review',
    committee: 'Finance Committee',
    date: '2023-09-15',
    time: '10:00 AM',
    type: 'Online',
    attendees: 8
  }, {
    id: 2,
    title: 'HR Policy Updates Discussion',
    committee: 'HR Committee',
    date: '2023-09-20',
    time: '11:30 AM',
    type: 'In-person',
    attendees: 6
  }, {
    id: 3,
    title: 'IT Security Protocol Review',
    committee: 'IT Committee',
    date: '2023-09-10',
    time: '02:00 PM',
    type: 'Online',
    attendees: 5
  }];
  const calendarEvents = [{
    id: 1,
    title: 'Finance Committee Monthly Review',
    date: '2023-09-15',
    committee: 'Finance Committee',
    type: 'Online'
  }, {
    id: 2,
    title: 'HR Policy Updates Discussion',
    date: '2023-09-20',
    committee: 'HR Committee',
    type: 'In-person'
  }, {
    id: 3,
    title: 'IT Security Protocol Review',
    date: '2023-09-10',
    committee: 'IT Committee',
    type: 'Online'
  }, {
    id: 4,
    title: 'Procurement Committee Quarterly Meeting',
    date: '2023-09-25',
    committee: 'Procurement Committee',
    type: 'In-person'
  }, {
    id: 5,
    title: 'Quality Assurance Review',
    date: '2023-09-18',
    committee: 'Quality Assurance Committee',
    type: 'Online'
  }];
  const handleSelectEvent = (eventId: number) => {
    window.location.href = `/meetings/${eventId}`;
  };
  return <div data-id="element-1566">
      <div className="flex justify-between items-center mb-6" data-id="element-1567">
        <h1 className="text-2xl font-bold" data-id="element-1568">Meetings</h1>
        <Link to="/meetings/add" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1569">
          <Plus size={18} className="mr-2" data-id="element-1570" />
          Schedule Meeting
        </Link>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1571">
        {/* Calendar View */}
        <div className="lg:col-span-2" data-id="element-1572">
          <CalendarComponent events={calendarEvents} onSelectEvent={handleSelectEvent} data-id="element-1573" />
        </div>
        {/* Upcoming Meetings */}
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1574">
          <h2 className="text-lg font-semibold mb-4" data-id="element-1575">Upcoming Meetings</h2>
          <div className="space-y-4" data-id="element-1576">
            {upcomingMeetings.map(meeting => <div key={meeting.id} className="border border-gray-200 rounded-lg p-4" data-id="element-1577">
                <h3 className="font-medium text-gray-900" data-id="element-1578">{meeting.title}</h3>
                <p className="text-sm text-gray-500 mb-2" data-id="element-1579">
                  {meeting.committee}
                </p>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1580">
                  <Calendar size={16} className="mr-2" data-id="element-1581" />
                  {meeting.date}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1582">
                  <Clock size={16} className="mr-2" data-id="element-1583" />
                  {meeting.time}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-1584">
                  {meeting.type === 'Online' ? <Video size={16} className="mr-2" data-id="element-1585" /> : <Users size={16} className="mr-2" data-id="element-1586" />}
                  {meeting.type}
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-1587">
                  <Users size={16} className="mr-2" data-id="element-1588" />
                  {meeting.attendees} Attendees
                </div>
                <div className="flex space-x-2" data-id="element-1589">
                  <Link to={`/meetings/${meeting.id}`} className="px-3 py-1 bg-orange-500 text-white text-sm rounded" data-id="element-1590">
                    View Details
                  </Link>
                  <button className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded flex items-center" data-id="element-1591">
                    <FileText size={14} className="mr-1" data-id="element-1592" />
                    Agenda
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}